export const tipoComplianceOptions = [
    {
        value: 'PROJETO',
        label: 'Projeto'
    },
    {
        value: 'SERVICO',
        label: 'Serviço'
    },
];
